webpackJsonp([237027443278143],{

/***/ 1236:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DosageTreatmentType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CRI"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICATION"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-dosage-treatment-type-d0f00e55f350d5a6550a.js